export default __webpack_public_path__ + "static/media/BG-DarkBlue-0003.5391944e.png";